import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "d-flex ga-3" }
const _hoisted_2 = { class: "mt-4" }
const _hoisted_3 = { class: "d-flex flex-wrap justify-center ga-2 mb-3" }
const _hoisted_4 = { class: "text-caption font-weight-regular opacity-60" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_footer = _resolveComponent("v-footer")!

  return (_openBlock(), _createBlock(_component_v_footer, {
    class: "text-left d-flex flex-column ga-2 py-4",
    color: "purple-darken-4"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialMedia, (social) => {
          return (_openBlock(), _createBlock(_component_v_btn, {
            key: social.icon,
            icon: social.icon,
            href: social.link,
            density: "comfortable",
            variant: "text"
          }, null, 8, ["icon", "href"]))
        }), 128))
      ]),
      _createVNode(_component_v_container, {
        fluid: "",
        class: _normalizeClass(_ctx.containerClasses)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "d-flex justify-space-around" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_divider, {
                color: "red",
                opacity: ".7",
                thickness: "3",
                gradient: "",
                vertical: ""
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.titleClasses)
                  }, "Majed Photograph", 2),
                  _createVNode(_component_v_divider, {
                    class: "my-2 w-50",
                    thickness: "2",
                    gradient: ""
                  }),
                  _createElementVNode("div", {
                    class: _normalizeClass([_ctx.bodyTextClasses, "ma-2"])
                  }, " Professionelle Fotografie-Dienstleistungen für unvergessliche Momente und beeindruckende visuelle Geschichten. ", 2)
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider, {
                color: "red",
                opacity: ".7",
                thickness: "3",
                gradient: "",
                vertical: ""
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass([_ctx.titleClasses, "mb-2"])
                  }, "Übersicht", 2),
                  _createVNode(_component_v_divider, {
                    class: "my-2 w-50",
                    thickness: "2",
                    gradient: ""
                  }),
                  _createElementVNode("div", {
                    class: _normalizeClass([_ctx.bodyTextClasses, "ma-2 cursor-pointer hover-text"]),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollToSection('HOME')))
                  }, "Startseite", 2),
                  _createElementVNode("div", {
                    clickable: "",
                    class: _normalizeClass([_ctx.bodyTextClasses, "ma-2 cursor-pointer hover-text"]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollToSection('ABOUT_ME')))
                  }, "Über mich", 2),
                  _createElementVNode("div", {
                    class: _normalizeClass([_ctx.bodyTextClasses, "ma-2 cursor-pointer hover-text"]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scrollToSection('PROJECTS')))
                  }, "Projekte", 2),
                  _createElementVNode("div", {
                    class: _normalizeClass([_ctx.bodyTextClasses, "ma-2 cursor-pointer hover-text"]),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.scrollToSection('SERVICES')))
                  }, "Leistungen", 2),
                  _createElementVNode("div", {
                    class: _normalizeClass([_ctx.bodyTextClasses, "ma-2 cursor-pointer hover-text"]),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.scrollToSection('TESTIMONIALS')))
                  }, "Kundenstimmen", 2),
                  _createElementVNode("div", {
                    class: _normalizeClass([_ctx.bodyTextClasses, "ma-2 cursor-pointer hover-text"]),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.scrollToSection('AQ')))
                  }, "Q&A", 2),
                  _createElementVNode("div", {
                    class: _normalizeClass([_ctx.bodyTextClasses, "ma-2 cursor-pointer hover-text"]),
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.scrollToSection('CONTACT')))
                  }, "Kontakt", 2)
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider, {
                color: "red",
                opacity: ".7",
                thickness: "3",
                gradient: "",
                vertical: ""
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, { class: "px-0" }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_avatar, {
                        image: require('../assets/majed.png'),
                        size: "80",
                        class: "border-sm bg-purple-darken-4 elevation-5"
                      }, null, 8, ["image"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, {
                        class: _normalizeClass(_ctx.titleClasses)
                      }, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createTextVNode(" Majed Muhanaia ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["class"]),
                      _createVNode(_component_v_list_item_subtitle, {
                        class: _normalizeClass(_ctx.subtitleClasses)
                      }, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                          _createTextVNode(" Gründer ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["class"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider, {
                    class: "my-2 w-25",
                    thickness: "2",
                    width: "50",
                    gradient: ""
                  }),
                  _createElementVNode("div", {
                    class: _normalizeClass([_ctx.subtitleClasses, "font-weight-regular opacity-60"])
                  }, [
                    _createVNode(_component_v_icon, {
                      class: "mr-1",
                      color: "primary"
                    }, {
                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                        _createTextVNode("mdi-format-quote-open", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[12] || (_cache[12] = _createTextVNode(" Mit Leidenschaft für außergewöhnliche Bilder. Ich halte deine wertvollsten Momente fest - von Porträts über Hochzeiten bis zur Unternehmensfotografie. Jedes Bild erzählt eine Geschichte. ", -1)),
                    _createVNode(_component_v_icon, {
                      class: "ml-auto",
                      color: "primary"
                    }, {
                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                        _createTextVNode("mdi-format-quote-close", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[13] || (_cache[13] = _createTextVNode(" - Majed Muhanaia ", -1))
                  ], 2),
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_v_chip, {
                        size: "small",
                        color: "success",
                        variant: "outlined",
                        "prepend-icon": "mdi-account-group"
                      }, {
                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                          _createTextVNode(" 100+ Kunden ", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_v_chip, {
                        size: "small",
                        color: "blue-lighten-1",
                        variant: "outlined",
                        "prepend-icon": "mdi-shield-check"
                      }, {
                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                          _createTextVNode(" 100% Garantie ", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_v_btn, {
                      color: "red-darken-3",
                      variant: "flat",
                      block: "",
                      class: "mb-3",
                      size: "large",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.scrollToSection('CONTACT')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { class: "mr-2" }, {
                          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                            _createTextVNode("mdi-calendar-clock", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[17] || (_cache[17] = _createTextVNode(" Termin: 030-1234567 ", -1))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_v_divider, {
        class: "my-2 w-100",
        thickness: "2"
      }),
      _createVNode(_component_v_divider),
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode(" © " + _toDisplayString(new Date().getFullYear()) + " - ", 1),
        _cache[18] || (_cache[18] = _createElementVNode("strong", null, "Majed Photography.", -1)),
        _cache[19] || (_cache[19] = _createTextVNode(" Alle Rechte vorbehalten. ", -1)),
        _cache[20] || (_cache[20] = _createElementVNode("a", {
          href: "/agb",
          class: "text-white opacity-75"
        }, "AGB", -1)),
        _cache[21] || (_cache[21] = _createTextVNode(" | ", -1)),
        _cache[22] || (_cache[22] = _createElementVNode("a", {
          href: "/impressum",
          class: "text-white opacity-75"
        }, "Impressum", -1)),
        _cache[23] || (_cache[23] = _createTextVNode(" | ", -1)),
        _cache[24] || (_cache[24] = _createElementVNode("a", {
          href: "/datenschutz",
          class: "text-white opacity-75"
        }, "Datenschutz", -1))
      ])
    ]),
    _: 1
  }))
}